import * as yup from "yup";
import { MB } from "../../../helpers/converters/fileHelpers";
import { FileVisibilityLevel } from "./fileVisibilityLevel";

const fileValidationSchema = (isCreateMode = true) => {
  return isCreateMode ? yup.object({
    visibility: yup.number()
      .typeError('Should be a number'),
    file: yup
      .mixed()
      .test('fileSize', 'File is too large', (file) => (file?.size || 0) < 50 * MB)
      .required('File is required'),
    country: yup
      .number()
      .typeError('Should be a number')
      .required('Country should be chosen'),
    locations: yup
      .array()
      .of(yup.number())
      .typeError('Should be a number')
      .min(1, 'At least one location should be chosen'),
    buildings: yup
      .array()
      .of(yup.number())
      .typeError('Should be a number')
      .when('visibility', {
        is: (visibility) => visibility === FileVisibilityLevel.BUILDING,
        then: yup.array().min(1, 'Set at least one building')
      })
  }) : yup.object({
    visibility: yup.number()
      .typeError('Should be a number'),
    country: yup
      .number()
      .typeError('Should be a number')
      .required('Country should be chosen'),
    locations: yup
      .array()
      .of(yup.number())
      .typeError('Should be a number')
      .min(1, 'At least one location should be chosen'),
    buildings: yup
      .array()
      .of(yup.number())
      .typeError('Should be a number')
      .when('visibility', {
        is: (visibility) => visibility === FileVisibilityLevel.BUILDING,
        then: yup.array().min(1, 'Set at least one building')
      })
  })
}

export default fileValidationSchema;